/**
 * TrustArc/Segment consent configuration for the realm selector.
 *
 * The category -> Segment destination mapping is kept in step with src-ui so that a
 * consent decision means the same thing in both apps.
 */
export const cookieManagerConfig: BrewCookieManager.Config = {
    container: '#consentManagerContainer', // Consent Manager container element selector
    toggle: '#cookieToggle', // Toggle button selector to open the TrustArc Consent Manager
    trustArc: {
        domain: 'adaptavist4.com', // Your TrustArc domain
        privacypolicylink: 'https://www.theadaptavistgroup.com/policy/privacy',
        cookieLink: 'https://www.theadaptavistgroup.com/policy/legal-notice',
        language: 'en',
    },
    segment: {
        // Hardcoded to match src-ui and client-ssr. The cookie manager is the only thing that
        // loads Segment here, so this one key both gates consent per destination and receives
        // the analytics.
        writeKey: 'Exb1vRwSWXzLEFVliX2JOcdXszAyIc7G',
        categories: {
            required: ['Security & Fraud'],
            functional: [
                'Attribution',
                'CRM',
                'Enrichment',
                'Feature Flagging',
                'Heatmaps & Recordings',
                'Performance Monitoring',
                'Personalization',
                'Referrals',
                'SMS & Push Notifications',
                'Tag Managers',
            ],
            advertising: ['Advertising'],
            marketing: [
                'A/B Testing',
                'Analytics',
                'Customer Success',
                'Deep Linking',
                'Email',
                'Email Marketing',
                'Livechat',
                'Marketing Automation',
                'Raw Data',
                'Surveys',
                'Video',
            ],
        },
    },
};
